import React from 'react';
import { ActionButtons, ScrDetails, contentStyle } from './ScrDetails';
import { Modal } from '@uy3/web-components';
import { IVencimento, SrcDataSet } from 'services/datasets';

interface ScrDetailsContainerProps {
    data: SrcDataSet;
    handleUpdateData: (dataset: string) => void;
    disableRequestDataSet?: boolean;
}

export const ScrDetailsContainer = ({
    data,
    handleUpdateData,
    disableRequestDataSet
}: ScrDetailsContainerProps) => {
    const [modal, setModal] = React.useState(false);
    const closeModal = () => setModal(false);
    const openModal = () => setModal(true);
    const listaDeResumoDeOperacoes = data?.result?.listaDeResumoDasOperacoes || [];

    const sortByCodigoVencimento = (a: IVencimento, b: IVencimento) => {
        const numA = Number(a.codigoVencimento.replace('v', ''));
        const numB = Number(b.codigoVencimento.replace('v', ''));
        return numA - numB;
    };

    return (
        <React.Fragment>
            <Modal
                title="Valores originais"
                open={modal}
                onClose={closeModal}
                children={<pre style={contentStyle}>{JSON.stringify(data, null, 2)}</pre>}
                sizeModal="large"
            />
            {listaDeResumoDeOperacoes?.map((operacao, idx) => (
                <ScrDetails
                    key={idx}
                    title={operacao?.modalidadeDisplay}
                    totalAmount={operacao?.listaDeVencimentos.reduce(
                        (acc, venc) => acc + (venc.valorVencimento || 0),
                        0
                    )}
                    installments={[...(operacao?.listaDeVencimentos ?? [])].sort(
                        sortByCodigoVencimento
                    )}
                    isLoading={disableRequestDataSet}
                />
            ))}
            <ActionButtons
                lastUpdate={data?.updatedAt}
                onViewOriginalData={openModal}
                onConsultAgain={() => handleUpdateData('ScrBcb')}
                disableRequestDataSet={disableRequestDataSet}
            />
        </React.Fragment>
    );
};
